





















































import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { DynamicScroller } from 'vue-virtual-scroller';
const dynamic = ['createUser', 'createSuperior'];
@Component({
	components: {
		DynamicScroller,
	},
})
export default class extends Vue {
	@Prop({ default: () => ({}) }) public item!: any;
	@Prop({ default: () => ({}) }) public form!: any;
	private popupValueArr: any = [];
	private searchValue = '';
	private showPicker = false;
	private get currentSelect() {
		console.log(
			this.members.filter((item) => {
				if (this.popupValueArr.includes(item.id)) {
					return true;
				}
			})
		);
		return this.members.filter((item) => {
			if (this.popupValueArr.includes(item.id)) {
				return true;
			}
		});
	}

	private cancel() {
		this.showPicker = false;
		this.popupValueArr = [];
		this.form.filterValue = '';
		this.$emit('change');
	}
	private get members() {
		let list = AppModule.workerList;
		return list.filter((item) => {
			if (item.name.includes(this.searchValue)) {
				return true;
			}
		});
	}
	private close(item) {
		// 转化为字符串
		let id = +item.id;
		let index = this.popupValueArr.indexOf(id);
		this.popupValueArr.splice(index, 1);
	}
	private comfirm() {
		this.form.filterValue = this.popupValueArr.join(',');
		this.showPicker = false;
		this.$emit('change');
	}

	private open() {
		this.showPicker = true;
	}
	private clear() {
		this.popupValueArr = [];
	}
	@Watch('$route.params.viewId')
	private ChildChanged() {
		this.popupValueArr = [];
	}
}
